import { SafeSessionLocationFilterSchema } from '@/src/domains/therapist-filters/constants'

export const parseTherapistSessionLocationFilterValue = (value: unknown) => SafeSessionLocationFilterSchema.parse(value)
